import type { FC } from "react";
import React from "react";

import { Content } from "../../../Content";

import type { OmitOfUnion } from "../../../../../types/react";
import type { ContentProps } from "../../../Content/Content";

const CONTENTS_VIEW_CONTENT_TEST_ID = "contents-view-content-test-id";

type ConstantContentProps = "size";
type ContentsViewContentProps = OmitOfUnion<ContentProps, ConstantContentProps>;

export const ContentsViewContent: FC<ContentsViewContentProps> = (props) => {
    return (
        <Content
            {...(props as ContentProps)}
            data-tsid={CONTENTS_VIEW_CONTENT_TEST_ID}
        />
    );
};

ContentsViewContent.displayName = "ContentsView.Content";

export default ContentsViewContent;
